import getSymbolFromCurrency from "currency-symbol-map";
import { useAtom } from "jotai";
import { animated } from "react-spring";
import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import { items_state, products_state, update_items_activeIds } from "../../dataManagers/GlobalDataManagers";
import { Boop } from "../Animations/Boop";

export const TextItem = ({ item, component, animation }) => {
  const [itemsState] = useAtom(items_state);
  const [productsState] = useAtom(products_state);
  const [, setItemsActiveIds] = useAtom(update_items_activeIds);
  const isActive = itemsState.activeIds[component._id]._id === item._id;
  const displayPrice = item.price > 0;

  const handleClick = () => {
    // abort if active item was reclicked
    if (itemsState.activeIds[component._id]._id === item._id) return;

    let copy = { ...itemsState.activeIds };
    copy[component._id] = { _id: item._id };

    setItemsActiveIds(copy);

    pushGTMAnalyticsEvent({
      event: "Item Click - Thrill",
      page: component.category,
      itemSection: component._id,
      item: item._id,
    });
  };

  return (
    <animated.div style={animation}>
      <Boop boopType="scale" scale={1.02} timing={200}>
        <div className="textItem">
          {displayPrice && isActive && (
            <p className="priceBlack imagePricePosition">{`${getSymbolFromCurrency(
              productsState.activeObj?.shopify?.currency?.active ?? "USD"
            )}${item.price}`}</p>
          )}
          <button onClick={handleClick} className={`rounded-button ${isActive ? "activeText" : ""}`}>
            {item.displayName}
          </button>
        </div>
      </Boop>
    </animated.div>
  );
};
